/** Stash list path + row for back continuity — plan/35 D · Wave F peek. */

type Stash = { listPath: string; rowId: string };

const KEY = "icraftx.listReturn";

function readStash(): Stash | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Stash;
    if (!parsed?.listPath || !parsed?.rowId) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

function matchesPrefix(listPath: string, listPathPrefix: string): boolean {
  return (
    listPath === listPathPrefix || listPath.startsWith(`${listPathPrefix}?`)
  );
}

export function stashListReturn(listPath: string, rowId: string): void {
  if (typeof sessionStorage === "undefined" || !listPath || !rowId) return;
  try {
    const payload: Stash = { listPath, rowId };
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch {
    /* private mode */
  }
}

/**
 * Read stash without consuming — for detail “Back to list” when filters were
 * stashed on open (plan/35 F).
 */
export function peekListReturn(listPathPrefix: string): Stash | null {
  const parsed = readStash();
  if (!parsed) return null;
  if (!matchesPrefix(parsed.listPath, listPathPrefix)) return null;
  return parsed;
}

/** Consume stash if it matches this list path prefix; otherwise leave it. */
export function takeListReturn(listPathPrefix: string): string | null {
  const parsed = readStash();
  if (!parsed) return null;
  if (!matchesPrefix(parsed.listPath, listPathPrefix)) return null;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
  return parsed.rowId;
}
